/** A calendar file of daily events — the only nudge a web app can guarantee is one the phone's
 *  calendar owns. Shared by the training reminders and the water reminders. */

function pad2(n: number): string {
  return String(n).padStart(2, "0");
}

/** One repeating daily event per `{ time: "HH:MM", title }`, each with an alarm at its start. */
export function icsCalendar(events: { time: string; title: string }[]): string {
  const now = new Date();
  const stamp =
    now.getUTCFullYear() +
    pad2(now.getUTCMonth() + 1) +
    pad2(now.getUTCDate()) +
    "T" +
    pad2(now.getUTCHours()) +
    pad2(now.getUTCMinutes()) +
    "00Z";

  const ev = ({ time, title }: { time: string; title: string }, i: number) => {
    const [h, m] = time.split(":").map(Number);
    const d = new Date();
    d.setHours(h, m, 0, 0);
    const local =
      d.getFullYear() + pad2(d.getMonth() + 1) + pad2(d.getDate()) + "T" + pad2(h) + pad2(m) + "00";
    return (
      "BEGIN:VEVENT\r\n" +
      `UID:kaya-${title.replace(/\W/g, "")}-${i}-${stamp}@kaya\r\n` +
      `DTSTAMP:${stamp}\r\n` +
      `DTSTART:${local}\r\n` +
      "RRULE:FREQ=DAILY\r\n" +
      `SUMMARY:${title}\r\n` +
      "BEGIN:VALARM\r\nTRIGGER:-PT0M\r\nACTION:DISPLAY\r\n" +
      `DESCRIPTION:${title}\r\n` +
      "END:VALARM\r\nEND:VEVENT\r\n"
    );
  };
  return "BEGIN:VCALENDAR\r\nVERSION:2.0\r\nPRODID:-//Kaya//EN\r\n" + events.map(ev).join("") + "END:VCALENDAR\r\n";
}

/** Hands the file to the browser as a download. Throws if the browser refuses. */
export function downloadIcs(name: string, text: string): void {
  const blob = new Blob([text], { type: "text/calendar" });
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = name;
  a.click();
  URL.revokeObjectURL(url);
}
